import { render, staticRenderFns } from "./AdminOrganizationUserEdit.vue?vue&type=template&id=c161edf0"
import script from "./AdminOrganizationUserEdit.vue?vue&type=script&lang=js"
export * from "./AdminOrganizationUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports